import { create } from "zustand";

const useToastStore = create((set, get) => ({
  toasts: [],
  toastCounter: 0,
  addToast: (toast) => {
    const id = Date.now();
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id, closing: false }],
      toastCounter: state.toastCounter + 1,
    }));

    if (toast.duration !== "infinite") {
      setTimeout(() => {
        get().removeToast(id);
      }, toast.duration || 3000);
    }
  },
  removeToast: (id) => {
    const toastToRemove = get().toasts.find((t) => t.id === id);
    if (!toastToRemove) return;

    set((state) => ({
      toasts: state.toasts.map((t) => (t.id === id ? { ...t, closing: true } : t)),
    }));

    setTimeout(() => {
      get()._removeToast(id);
    }, toastToRemove.animationDuration || 300);
  },
  _removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    }));
  },
}));

export default useToastStore;
